// ----------------------------------------------------------------------------
// Component: Scrolling Gallery
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, Autoplay, FreeMode, Mousewheel } from 'swiper';
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/icon/icon';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';
import 'swiper/css/mousewheel';
import 'swiper/css/free-mode';
import './_scrolling-gallery.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {

    $(".carousel--scrolling-gallery").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("scrolling-gallery-instance-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".scrolling-gallery-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Autoplay, FreeMode, Mousewheel],
            slidesPerView: 1,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 10000,
            loop: true,
            touchRatio: .3,
            spaceBetween: 5,
            effect: 'slide',
            simulateTouch: true,
            freeMode: {
                enabled: true
            },
            mousewheel: {
                sensitivity: .5,
            },

            breakpoints: {
                // when window width is >= 680px
                680: {
                    slidesPerView: 3,
                }
            },
        });
    });
});